var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RestaurantDetailComponent',{attrs:{"restaurant":_vm.restaurant,"loading":_vm.loading_tag},on:{"addTags":_vm.addTags,"untag":_vm.untag,"addAndRemoveTags":_vm.addAndRemoveTags}})}
var staticRenderFns = []

export { render, staticRenderFns }